// Style of tap highlight
export var baseHighlightStyle = "\n  -webkit-tap-highlight-color: transparent;\n  ::-moz-focus-inner {\n    border: 0;\n  }\n";